<template>
  <div>
    <!-- dilaog -->

    <v-card-title class="dialog_header">{{
      $t("headings.product_order_details")
    }}</v-card-title>
    <v-card-text v-if="!loading">
      <v-list flat>
        <v-list-item-group>
          <router-link :to="`/users?name=${order.user.firstname}`">
            <v-list-item>
              <v-list-item-icon>
                <v-avatar size="80" :title="$t('labels.user_photo')">
                  <template v-if="order.user && order.user.photo">
                    <v-img :src="order.user && order.user.photo.path"></v-img>
                  </template>
                  <template v-else>
                    <v-icon large>mdi-account</v-icon>
                  </template>
                </v-avatar>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title :title="$t('labels.name')">
                  {{ order.user && order.user.firstname }}
                  {{ order.user && order.user.lastname }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <v-avatar size="80" :title="$t('labels.product_photo')">
                <v-img
                  :src="order.product && order.product.main_image.path"
                ></v-img>
              </v-avatar>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title :title="$t('labels.name')">
                {{ order.product && order.product.name }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <strong>{{ $t("labels.total_price") }}</strong>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title :title="$t('labels.total_price')">
                {{ order && order.total_price }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <strong>{{ $t("labels.qty") }}</strong>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title :title="$t('labels.qty')">
                {{ order.product && order.product.qty }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <strong>{{ $t("labels.proudct_components") }}</strong>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-if="order.product">
                <v-chip
                  class="mx-2"
                  v-for="(component, index) in order.product.components"
                  :key="index"
                  >{{ component }}</v-chip
                >
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
        </v-list-item-group>
      </v-list>
    </v-card-text>
    <div class="text-center pa-5" v-else>
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>

    <!-- dilaog -->
  </div>
</template>

<script>
export default {
  name: "OrderDetails",
  props: {
    order: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    if (this.order) {
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    }
  },
  data() {
    return {
      loading: true
    };
  }
};
</script>
